/* eslint-disable react/display-name */
import * as React from 'react';

import * as styles from './styles/segment.css';

type ISegmentGroupProps = React.HTMLProps<HTMLDivElement>;

export const SegmentGroup = React.forwardRef<HTMLDivElement, ISegmentGroupProps>(({ children }, ref) => (
  <div ref={ref} className={styles['segment_group']}>
    {children}
  </div>
));
